export type Condition = {
    type: ConditionType;
    values: string[];
    actionType: ConditionActionType;
    destinationQuestionId: string;
};

export type ConditionOptionType = {
    displayName: string;
    value: ConditionType;
};

export type ConditionType = 
    "is" | "is_not" | "contains" | "does_not_contain" | "starts_with" | 
    "ends_with" | "is_empty" | "is_not_empty" | "is_greater_than" | 
    "is_less_than" | "is_between" | "is_any_of" | "is_not_any_of";

export enum ConditionActionType {
    JUMP = "JUMP",
    CALCULATE = "CALCULATE",
};


export const CONDITION_IS = {
    displayName: "is equal to",
    value: "is" as ConditionType
} as ConditionOptionType;

export const CONDITION_IS_NOT = {
    displayName: "is not equal to",
    value: "is_not" as ConditionType
} as ConditionOptionType;

export const CONDITION_CONTAINS = {
    displayName: "contains",
    value: "contains" as ConditionType
} as ConditionOptionType;

export const CONDITION_DOES_NOT_CONTAIN = {
    displayName: "does not contain",
    value: "does_not_contain" as ConditionType
} as ConditionOptionType;

export const CONDITION_STARTS_WITH = {
    displayName: "starts with",
    value: "starts_with" as ConditionType
} as ConditionOptionType;

export const CONDITION_ENDS_WITH = {
    displayName: "ends with",
    value: "ends_with" as ConditionType
} as ConditionOptionType;

export const CONDITION_IS_EMPTY = {
    displayName: "is empty",
    value: "is_empty" as ConditionType
} as ConditionOptionType;

export const CONDITION_IS_NOT_EMPTY ={
    displayName: "is not empty",
    value: "is_not_empty" as ConditionType
} as ConditionOptionType;

export const CONDITION_IS_GREATER_THAN = {
    displayName: "is greater than",
    value: "is_greater_than" as ConditionType
} as ConditionOptionType;

export const CONDITION_IS_LESS_THAN = {
    displayName: "is less than",
    value: "is_less_than" as ConditionType
} as ConditionOptionType;

export const CONDITION_IS_BETWEEN = {
    displayName: "is between",
    value: "is_between" as ConditionType
} as ConditionOptionType;

export const CONDITION_IS_ANY_OF = {
    displayName: "is any of",
    value: "is_any_of" as ConditionType
} as ConditionOptionType;

export const CONDITION_IS_NOT_ANY_OF = {
    displayName: "is not any of",
    value: "is_not_any_of" as ConditionType
} as ConditionOptionType;

export const CONDITIONS_SHORT: ConditionOptionType[]= 
[
    CONDITION_IS, CONDITION_IS_NOT, CONDITION_CONTAINS, CONDITION_DOES_NOT_CONTAIN,
    CONDITION_STARTS_WITH, CONDITION_ENDS_WITH, CONDITION_IS_EMPTY, CONDITION_IS_NOT_EMPTY,
];

export const CONDITIONS_LONG: ConditionOptionType[] = 
[
    CONDITION_IS, CONDITION_IS_NOT, CONDITION_CONTAINS, CONDITION_DOES_NOT_CONTAIN,
    CONDITION_STARTS_WITH, CONDITION_ENDS_WITH, CONDITION_IS_EMPTY, CONDITION_IS_NOT_EMPTY,
];

export const CONDITIONS_EMAIL: ConditionOptionType[] =
[
    CONDITION_IS, CONDITION_IS_NOT, CONDITION_CONTAINS, CONDITION_DOES_NOT_CONTAIN,
    CONDITION_STARTS_WITH, CONDITION_ENDS_WITH, CONDITION_IS_EMPTY, CONDITION_IS_NOT_EMPTY,
];

export const CONDITIONS_WEBSITE: ConditionOptionType[] =
[
    CONDITION_IS, CONDITION_IS_NOT, CONDITION_CONTAINS, CONDITION_DOES_NOT_CONTAIN,
    CONDITION_STARTS_WITH, CONDITION_ENDS_WITH, CONDITION_IS_EMPTY, CONDITION_IS_NOT_EMPTY,
];

export const CONDITIONS_NUMBER: ConditionOptionType[] =
[
    CONDITION_IS, CONDITION_IS_NOT, CONDITION_IS_GREATER_THAN, CONDITION_IS_LESS_THAN, CONDITION_IS_BETWEEN,
    CONDITION_IS_EMPTY, CONDITION_IS_NOT_EMPTY,
];

export const CONDITIONS_DATE: ConditionOptionType[] =
[
    CONDITION_IS, CONDITION_IS_NOT, CONDITION_IS_GREATER_THAN, CONDITION_IS_LESS_THAN, CONDITION_IS_BETWEEN,
];

export const CONDITIONS_MULTIPLE: ConditionOptionType[] =
[
    CONDITION_IS, CONDITION_IS_NOT, CONDITION_IS_ANY_OF, CONDITION_IS_NOT_ANY_OF, 
    CONDITION_IS_EMPTY, CONDITION_IS_NOT_EMPTY,
];

export const CONDITIONS_FILE_UPLOAD: ConditionOptionType[] = [
    CONDITION_IS_EMPTY, CONDITION_IS_NOT_EMPTY,
];

export const CONDITIONS_PHONE: ConditionOptionType[] = [
    CONDITION_IS_EMPTY, CONDITION_IS_NOT_EMPTY,
];

export const CONDITIONS_CHECKBOX: ConditionOptionType[] = [
    CONDITION_IS, CONDITION_IS_NOT
];

export const CONDITIONS_TIME: ConditionOptionType[] = [
    CONDITION_IS, CONDITION_IS_NOT, CONDITION_IS_GREATER_THAN, CONDITION_IS_LESS_THAN, CONDITION_IS_BETWEEN,
    CONDITION_IS_EMPTY, CONDITION_IS_NOT_EMPTY,
];

export const CONDITIONS_CONTACT: ConditionOptionType[] = [
    CONDITION_IS_EMPTY, CONDITION_IS_NOT_EMPTY,
];

export const CONDITIONS_NPS: ConditionOptionType[] = [
    CONDITION_IS, CONDITION_IS_NOT, CONDITION_IS_GREATER_THAN, CONDITION_IS_LESS_THAN, CONDITION_IS_BETWEEN,
    CONDITION_IS_EMPTY, CONDITION_IS_NOT_EMPTY,
];

export const CONDITIONS_SCORE: ConditionOptionType[] = [
    CONDITION_IS, CONDITION_IS_NOT, CONDITION_IS_GREATER_THAN, CONDITION_IS_LESS_THAN, CONDITION_IS_BETWEEN,
    CONDITION_IS_EMPTY, CONDITION_IS_NOT_EMPTY,
];

export const CONDITIONS_RATING: ConditionOptionType[] = [
    CONDITION_IS, CONDITION_IS_NOT, CONDITION_IS_GREATER_THAN, CONDITION_IS_LESS_THAN, CONDITION_IS_BETWEEN,
    CONDITION_IS_EMPTY, CONDITION_IS_NOT_EMPTY,
];

export const CONDITIONS_SECTION: ConditionOptionType[] = [
];

export const CONDITIONS_INITIAL = {
    SHORT: CONDITIONS_SHORT,
    LONG: CONDITIONS_LONG,
    EMAIL: CONDITIONS_EMAIL,
    WEBSITE: CONDITIONS_WEBSITE,
    NUMBER: CONDITIONS_NUMBER,
    DATE: CONDITIONS_DATE,
    MULTIPLE: CONDITIONS_MULTIPLE,
    FILE_UPLOAD: CONDITIONS_SHORT,
    PHONE: CONDITIONS_PHONE,
    CHECKBOX: CONDITIONS_CHECKBOX,
    TIME: CONDITIONS_TIME,
    CONTACT: CONDITIONS_CONTACT,
    NPS: CONDITIONS_NPS,
    SCORE: CONDITIONS_SCORE,
    RATING: CONDITIONS_RATING,
    SECTION: CONDITIONS_SECTION,
    END: CONDITIONS_SHORT
}